export {default as data} from './index.json';
import {Component} from 'intact';
import template from './index.vdt';

import {Notification} from 'kpc';

export default class extends Component {
    static template = template;

    showNotification() {
        Notification.notice({
            title: 'Hello, Kingcloud Design!',
            content: '这是一条基础用法的通知'
        });
    }
}